import React from "react";
import { Box, Paper } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";

import useStyles from "./styles";

export default function CustomExpandCardSkeleton() {
  const styles = useStyles();

  return (
    <Box className={styles.accordion}>
      <Paper className={styles.cardContainer}>
        <Box display="flex" alignItems="center" mb={2} gridGap={20}>
          <Skeleton variant="circle" width={80} height={80} />
          <Box ml={2}>
            <Skeleton
              variant="text"
              width={120}
              height={28}
              style={{ marginBottom: 4 }}
            />
            <Box display="flex" alignItems="center" gridGap={4}>
              <Skeleton variant="text" width={60} height={20} />
              <Skeleton
                variant="rect"
                width={20}
                height={20}
                style={{ borderRadius: 4 }}
              />
            </Box>
          </Box>
          <Box>
            <Box display="flex" alignItems="center" mt={1}>
              <Skeleton variant="rect" width={120} height={18} />
              <Skeleton variant="rect" width={120} height={18} />
            </Box>
            <Box display="flex" alignItems="center" mt={1}>
              <Skeleton variant="rect" width={120} height={18} />
              <Skeleton variant="rect" width={120} height={18} />
            </Box>
            <Box display="flex" alignItems="center" mt={1}>
              <Skeleton variant="rect" width={120} height={18} />
              <Skeleton variant="rect" width={120} height={18} />
            </Box>
          </Box>
          <Box
            display="flex"
            alignItems="flex-end"
            justifyContent="space-between"
            mb={1}
            gridGap={16}
          >
            <Box>
              <Skeleton variant="text" width={120} height={18} />
              <Skeleton variant="text" width={90} height={22} />
            </Box>
            <Box>
              <Skeleton variant="text" width={120} height={18} />
              <Skeleton variant="text" width={90} height={22} />
            </Box>
            <Box>
              <Skeleton variant="text" width={120} height={18} />
              <Skeleton variant="text" width={90} height={22} />
            </Box>
            <Box>
              <Skeleton variant="text" width={120} height={18} />
              <Skeleton variant="text" width={90} height={22} />
            </Box>
            <Box>
              <Skeleton variant="text" width={120} height={18} />
              <Skeleton variant="text" width={90} height={22} />
            </Box>
            <Box>
              <Skeleton variant="text" width={120} height={18} />
              <Skeleton variant="text" width={90} height={22} />
            </Box>
            {/* Expand Icon */}
            <Box ml={2} display="flex" alignSelf="flex-end">
              <Skeleton variant="circle" width={28} height={28} />
            </Box>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
}
